'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { signIn } from 'next-auth/react';
import { Loader2 } from 'lucide-react';
import { ruDomenAisearch } from '@/lib/authentik-flow';
import { adresVhodaYandex } from '@/lib/vhod-yandex';

/**
 * Кнопка «Войти через Яндекс ID». Только на русской витрине AiSearch.
 *
 * Домен проверяется в браузере после монтирования, а не при отрисовке:
 * сервер за прокси не всегда знает домен, и расхождение ломало бы гидрацию.
 * Устройство входа описано в `lib/vhod-yandex.ts`.
 */
export function VhodYandex({ callbackUrl }: { callbackUrl: string }) {
  const t = useTranslations('login');
  const [vidna, setVidna] = useState(false);
  const [pending, setPending] = useState(false);
  const [oshibka, setOshibka] = useState(false);

  useEffect(() => {
    setVidna(ruDomenAisearch(window.location.hostname));
  }, []);

  if (!vidna) return null;

  const voiti = async () => {
    setPending(true);
    setOshibka(false);
    try {
      // redirect: false — Auth.js кладёт state и PKCE в cookie и отдаёт адрес
      // authorize, а не уводит сам. Уводим мы, через поток Яндекса.
      const res = await signIn('authentik', { redirect: false, redirectTo: callbackUrl });
      const adres = res.url ? adresVhodaYandex(res.url) : null;
      if (!adres) {
        setOshibka(true);
        setPending(false);
        return;
      }
      window.location.href = adres;
    } catch {
      setOshibka(true);
      setPending(false);
    }
  };

  return (
    <div className="mt-4">
      <div className="flex items-center gap-3 mb-4 text-xs text-[var(--color-text-muted)]">
        <span className="h-px flex-1 bg-[var(--color-border)]" />
        {t('or')}
        <span className="h-px flex-1 bg-[var(--color-border)]" />
      </div>
      <button
        type="button"
        onClick={() => void voiti()}
        disabled={pending}
        className="w-full inline-flex items-center justify-center gap-2 rounded-xl border border-[var(--color-border)] bg-[var(--color-bg)] px-4 py-3 text-sm font-medium text-[var(--color-text)] hover:border-[var(--color-accent-400)] transition-colors disabled:opacity-50"
      >
        {pending ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <span
            aria-hidden="true"
            className="inline-flex w-5 h-5 items-center justify-center rounded-full bg-[#fc3f1d] text-white text-xs font-bold"
          >
            Я
          </span>
        )}
        {t('yandex')}
      </button>
      {oshibka && <p className="mt-2 text-sm text-red-400 text-center">{t('yandex_error')}</p>}
    </div>
  );
}
